var _defs, _path, _rect, _rect2, _rect3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTechnicalIcons6 = function SvgTechnicalIcons6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "technical_icons_6_svg__ico_x5F_akutermiczne_x5F_dno",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".technical_icons_6_svg__st0{fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "technical_icons_6_svg__st0",
    d: "M36.7 98.9h-7.6c-.5 0-1 .4-.9.9l.5 4.6c0 .5.4.9.9.9h7c.5 0 .9-.4.9-.9v-4.6c0-.5-.4-.9-.9-.9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.4,
    y: 98.9,
    width: 9.4,
    height: 6.5,
    rx: 0.9,
    ry: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.7,
    y: 98.9,
    width: 9.4,
    height: 6.5,
    rx: 0.9,
    ry: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 98.9,
    width: 9.4,
    height: 6.5,
    rx: 0.9,
    ry: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "technical_icons_6_svg__st0",
    d: "M101.4 98.9h-7.6c-.5 0-.9.4-.9.9v4.6c0 .5.4.9.9.9h7c.5 0 .9-.4.9-.9l.5-4.6c0-.5-.4-.9-.9-.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "technical_icons_6_svg__st0",
    d: "M123.3 27.9H115v-8c0-1-.8-1.8-1.8-1.8h-2.9c-1 0-1.8.8-1.8 1.8v67.2H20.9V19.9c0-1-.8-1.8-1.8-1.8h-2.9c-1 0-1.8.8-1.8 1.8v8H6.1c-1 0-1.8.8-1.8 1.8v2.9c0 1 .8 1.8 1.8 1.8h8.3v57.7l2.1 19.8c.3 3 2.4 5.4 5.4 5.4h85.6c3 0 5.1-2.5 5.4-5.4l2.1-19.8V34.4h8.3c1 0 1.8-.8 1.8-1.8v-2.9c0-1-.8-1.8-1.8-1.8Zm-16.8 80.9c-.1 1-.9 1.9-1.9 1.9H24.8c-1 0-1.8-.9-1.9-1.9L21 93.6h87.4l-1.9 15.2Z"
  })));
};
export default SvgTechnicalIcons6;